<container-dashboard-layout>
  <router-outlet></router-outlet>
</container-dashboard-layout>

<app-brain-webchat />
